import { Icon } from "@atoms";
import { PERMISSION_LEVEL } from "@constants/permissionLevel";
import BasicSelectField from "@legacy/core/fields/BasicSelectField";
import { FileUpload } from "@molecules";
import { faIcon } from "@utils/faIcon";
import { Component, Fragment } from "react";
import ContactSearchOrCreateSelect, { contactToContactOption } from "../../../clients/inputs/ContactSearchOrCreateSelect";
import BooleanField from "../../../core/fields/BooleanField";
import SearchCreateSelectField from "../../../core/fields/SearchCreateSelectField";
import TagField from "../../../core/fields/TagField";
import TextField from "../../../core/fields/TextField";
import TagSearchInput from "../../../core/inputs/TagSearchInput";
import { valueIsDefined } from "../../../core/utils/utils";
import EquipmentSearchOrCreateSelect, { equipmentToEquipmentOption } from "../../../equipment/inputs/EquipmentSearchOrCreateSelect";

class JobEditableDetailsFields extends Component {

    constructor(props) {
        super(props)

        this.state = {
            serviceSearchInput: "",
            reporterSearchInput: "",
            pointOfContactSearchInput: "",
            equipmentSearchInput: "",

            triggerCommit: false,
            triggerDiscard: false,
            pendingAction: null,
        }
    }

    handleSaveAction = (action) => {
        const { job, requestAction } = this.props

        if (job.id && window.FILE_UPLOADS_ENABLED) {
            this.setState({ triggerCommit: true, pendingAction: action })
        } else {
            requestAction(action)
        }
    }

    handleCancelAction = (action) => {
        const { job, requestAction } = this.props

        if (job.id && window.FILE_UPLOADS_ENABLED) {
            this.setState({ triggerDiscard: true, pendingAction: action })
        } else {
            requestAction(action)
        }
    }

    render() {
        const {
            mode,
            submitting,
            job,
            errors,
            onFormDataChange,
            requestAction,
            switchToSecondaryForm,
            updateReporterSelection,
            updatePointOfContactSelection,
            updateEquipmentSelection,
            selectedClient,
            selectedServiceLocation,
            selectedReporter,
            selectedPointOfContact,
            selectedEquipment,
            defaultCountryCode,
            updateAttachments,
            removePendingAttachment,
            setIsUploading,
            pendingSessionId,
            priorityLevelsOptions,
        } = this.props

        return (
            <Fragment>
                <TextField
                    fieldName="details"
                    fieldLabel={job.is_recall ? "Reason For Recall" : "Reason For Call"}
                    fieldValue={job.details || ""}
                    fieldOnChange={details => onFormDataChange("details", details || "")}
                    rows={3}
                    placeholder="Customer states..."
                    errors={errors}
                ></TextField>
                <TextField
                    fieldName="technician_instructions"
                    fieldLabel="Technician Instructions"
                    fieldValue={job.technician_instructions || ""}
                    fieldOnChange={technician_instructions => onFormDataChange("technician_instructions", technician_instructions || "")}
                    rows={3}
                    placeholder={`Notes specific to this ${job.is_job_walk ? "job walk" : "service"}. e.g. 'Ask client about replacing the unit.' or 'Make sure to collect payment on site.'`}
                    optional={true}
                    errors={errors}
                ></TextField>
                <BasicSelectField
                    fieldName="priority"
                    fieldLabel="Priority"
                    fieldValue={job.priority}
                    fieldOnChange={priority => onFormDataChange("priority", priority)}
                    choices={priorityLevelsOptions}
                    errors={errors}
                ></BasicSelectField>
                <TagField
                    fieldName="labels"
                    fieldLabel="Labels"
                    inputComponent={
                        <TagSearchInput
                            defaultSelectedTags={job.labels?.map(label => label.name)}
                            onSelectionChange={labelNames => onFormDataChange("labels", labelNames ? labelNames.map(labelName => ({"name": labelName})) : [])}
                            choicesEndpoint={DjangoUrls["jobs:api-jobs-labels-list"](window.MARKETPLACE_ENTITY_SLUG)}
                            placeholder="Add Labels..."
                            noOptionsMessage="No Labels Found"
                            isMulti={true}
                        ></TagSearchInput>
                    }
                    optional={true}
                    errors={errors}
                ></TagField>
                <BooleanField
                    fieldName="equipment_expected"
                    fieldLabel="Equipment Expected"
                    fieldValue={job.equipment_expected}
                    fieldOnChange={equipment_expected => {onFormDataChange("equipment_expected", equipment_expected); equipment_expected === false ? updateEquipmentSelection([]) : null}}
                    inputLabel="Is Equipment involved on this Job?"
                    errors={errors}
                ></BooleanField>
                {
                    job.equipment_expected && (
                        <SearchCreateSelectField
                            fieldName="equipment"
                            fieldLabel="Equipment"
                            fieldValue={(selectedEquipment.length !== 0 ? selectedEquipment.map(equipment => equipment.display_name).join(", ") : "")}
                            inputComponent={
                                <EquipmentSearchOrCreateSelect
                                    disabled={window.CURRENT_USER?.permissions.equipment_list_permission < PERMISSION_LEVEL.RESTRICTED}
                                    isMulti={true}
                                    refetchSelection={false}
                                    onSelectionChange={selectedOptions => updateEquipmentSelection((selectedOptions || []).map(option => option.object))}
                                    onInputChange={(input, action) => {action.action === "input-change" && this.setState({equipmentSearchInput: input})}}
                                    defaultSelected={selectedEquipment.map(equipment => equipmentToEquipmentOption(equipment))}
                                    serviceLocation={selectedServiceLocation}
                                    showCreateButton={window.CURRENT_USER?.permissions.equipment_create_permission >= PERMISSION_LEVEL.FULL}
                                    onCreateClick={event => switchToSecondaryForm("ADD_EQUIPMENT", null, {display_name: this.state.equipmentSearchInput})}
                                ></EquipmentSearchOrCreateSelect>
                            }
                            showButton={window.CURRENT_USER?.permissions.equipment_list_permission >= PERMISSION_LEVEL.FULL}
                            buttonLabel={<Fragment>View/Edit Logged Equipment{"  "}<Icon containerClassName="icon-inline" icon={faIcon({ name: "arrow-up-right-from-square", style: "regular" })} /></Fragment>}
                            buttonAction={event => window.open(DjangoUrls["clients:clients-equipment"](window.MARKETPLACE_ENTITY_SLUG, selectedClient.id) + `?service_location_id=${selectedServiceLocation.id}`, "_blank")}
                            errors={errors}
                        ></SearchCreateSelectField>
                    )
                }
                <SearchCreateSelectField
                    fieldName="reporter"
                    fieldLabel={`Who called in this ${job.is_job_walk ? "job walk" : "service"}?`}
                    fieldValue={selectedReporter ? selectedReporter.name : null}
                    inputComponent={
                        <ContactSearchOrCreateSelect
                            disabled={window.CURRENT_USER?.permissions.clients_view_permission < PERMISSION_LEVEL.FULL}
                            fieldName="reporter"
                            onSelectionChange={selectedOption => updateReporterSelection(selectedOption != null ? selectedOption.object : null)}
                            onInputChange={(input, action) => {action.action === "input-change" && this.setState({reporterSearchInput: input})}}
                            defaultSelected={selectedReporter ? contactToContactOption(selectedReporter, null) : null}
                            client={selectedClient}
                            serviceLocation={selectedServiceLocation}
                            showCreateButton={window.CURRENT_USER?.permissions.clients_edit_permission >= PERMISSION_LEVEL.FULL}
                            onCreateClick={event => switchToSecondaryForm("ADD_CONTACT", null, {name: this.state.reporterSearchInput, populationRef: "updateReporterSelection"})}
                        ></ContactSearchOrCreateSelect>
                    }
                    showButton={selectedReporter !== null && valueIsDefined(selectedReporter.id) && !valueIsDefined(selectedReporter.__isNonExistant__) && window.CURRENT_USER?.permissions.clients_edit_permission >= PERMISSION_LEVEL.FULL}
                    buttonLabel={<Fragment><Icon containerClassName="icon-inline" icon={faIcon({ name: "pen-to-square", style: "regular" })} />Edit Contact</Fragment>}
                    buttonAction={event => switchToSecondaryForm("EDIT_CONTACT", selectedReporter, {populationRef: "updateReporterSelection", dataRef: "selectedReporter"})}
                    errors={errors}
                ></SearchCreateSelectField>
                <SearchCreateSelectField
                    fieldName="point_of_contact"
                    fieldLabel="Who should the tech(s) ask for?"
                    fieldValue={selectedPointOfContact ? selectedPointOfContact.name : null}
                    inputComponent={
                        <ContactSearchOrCreateSelect
                            disabled={window.CURRENT_USER?.permissions.clients_view_permission < PERMISSION_LEVEL.FULL}
                            fieldName="point_of_contact"
                            onSelectionChange={selectedOption => updatePointOfContactSelection(selectedOption != null ? selectedOption.object : null)}
                            onInputChange={(input, action) => {action.action === "input-change" && this.setState({pointOfContactSearchInput: input})}}
                            defaultSelected={selectedPointOfContact ? contactToContactOption(selectedPointOfContact, null) : null}
                            client={selectedClient}
                            serviceLocation={selectedServiceLocation}
                            showCreateButton={window.CURRENT_USER?.permissions.clients_edit_permission >= PERMISSION_LEVEL.FULL}
                            onCreateClick={event => switchToSecondaryForm("ADD_CONTACT", null, {name: this.state.pointOfContactSearchInput, populationRef: "updatePointOfContactSelection"})}
                        ></ContactSearchOrCreateSelect>
                    }
                    showButton={selectedPointOfContact !== null && valueIsDefined(selectedPointOfContact.id) && !valueIsDefined(selectedPointOfContact.__isNonExistant__) && window.CURRENT_USER?.permissions.clients_edit_permission >= PERMISSION_LEVEL.FULL}
                    buttonLabel={<Fragment><Icon containerClassName="icon-inline" icon={faIcon({ name: "pen-to-square", style: "regular" })} />Edit Contact</Fragment>}
                    buttonAction={event => switchToSecondaryForm("EDIT_CONTACT", selectedPointOfContact, {populationRef: "updatePointOfContactSelection", dataRef: "selectedPointOfContact"})}
                    errors={errors}
                ></SearchCreateSelectField>
                {
                    window.FILE_UPLOADS_ENABLED && job.id && (
                        <div className="data-panel__form__field">
                            <FileUpload
                                mode="attached"
                                objectType="job"
                                objectId={job.id}
                                existingAttachments={job.attachments}
                                autoUpload={true}
                                autoCommit={false}
                                triggerCommit={this.state.triggerCommit}
                                triggerDiscard={this.state.triggerDiscard}
                                label={{ label: "Attachments", condition: "optional" }}
                                onCommitComplete={() => {
                                    const action = this.state.pendingAction
                                    this.setState({ triggerCommit: false, pendingAction: null })
                                    if (action) {
                                        requestAction(action)
                                    }
                                }}
                                onDiscardComplete={() => {
                                    const action = this.state.pendingAction
                                    this.setState({ triggerDiscard: false, pendingAction: null })
                                    if (action) {
                                        requestAction(action)
                                    }
                                }}
                                onUploadingChange={(isUploading) => {
                                    if (setIsUploading) {
                                        setIsUploading(isUploading)
                                    }
                                }}
                                onFileUploadError={(file, error) => {
                                    console.error("Job attachment upload error:", file.name, error)
                                }}
                            />
                        </div>
                    )
                }
                {
                    window.FILE_UPLOADS_ENABLED && !job.id && (
                        <div className="data-panel__form__field">
                            <FileUpload
                                mode="pending"
                                objectType="job"
                                sessionId={pendingSessionId}
                                autoUpload={true}
                                label={{ label: "Attachments", condition: "optional" }}
                                onPendingFileUploadComplete={(result) => {
                                    updateAttachments([{
                                        file: result.file,
                                        filePath: result.filePath,
                                        fileUrl: result.fileUrl,
                                        upload_filename: result.file.name,
                                        upload_mimetype: result.file.type,
                                        upload_size: result.file.size,
                                        sessionId: result.sessionId,
                                        isPending: true,
                                    }])
                                }}
                                onFileRemove={(filename) => {
                                    if (removePendingAttachment) {
                                        removePendingAttachment(filename)
                                    }
                                }}
                                onFileUploadError={(file, error) => {
                                    console.error("Pending job attachment upload error:", file.name, error)
                                }}
                                onUploadingChange={(isUploading) => {
                                    if (setIsUploading) {
                                        setIsUploading(isUploading)
                                    }
                                }}
                            />
                        </div>
                    )
                }
            </Fragment>
        )
    }
}

export default JobEditableDetailsFields;
